import { render, staticRenderFns } from "./editPhone.vue?vue&type=template&id=5062f68c&scoped=true"
import script from "./editPhone.vue?vue&type=script&lang=ts"
export * from "./editPhone.vue?vue&type=script&lang=ts"
import style0 from "./editPhone.vue?vue&type=style&index=0&id=5062f68c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5062f68c",
  null
  
)

export default component.exports